<template>
  <div class="refund-logistics-form-container">
    <div class="form">
      <div class="form-item">
        <div class="title">快递单号</div>
        <div class="content">
          <input
            type="text"
            placeholder="请填入快递单号"
            v-model="expressNum"
          />
        </div>
      </div>
      <div class="form-item">
        <div class="title">快递公司</div>
        <div class="content" @click.prevent="logisticsOpen">
          <span :class="{'express-name-none':expressName==''}">{{expressName || '请填入快递公司名字'}}</span>
        </div>
      </div>
    </div>
    <div class="action-btn" @click="submit">提交</div>

    <ListPopUp
      ref="listPopUp"
      :list="logisticsList"
      indexName="name"
      style-type="refund"
      :show-default-selectd="false"
      @select="handleSelected"
    ></ListPopUp>
  </div>
</template>

<script>
import ListPopUp from "@components/ListPopUp";
import { getExpressList, submitExpressInfo } from "@api/user";
export default {
  name: "RefundLogisticsForm",
  components: {
    ListPopUp
  },
  data() {
    return {
      logisticsList: [],
      id: null, // 售后id
      expressName: "", // 快递公司名字
      expressNum: "" // 快递单号
    };
  },
  mounted() {
    if (!this.$route.query.hasOwnProperty("id")) {
      this.$dialog.error("参数异常");
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    } else {
      this.id = this.$route.query.id;
      this.getExpressList();
    }
  },
  methods: {
    /**
     * 获取快递列表
     */
    getExpressList() {
      getExpressList().then(res => {
        res.data.forEach(item => {
          this.logisticsList.push({ name: item });
        });
        console.log(res);
      });
    },
    /**
     * 处理选择后
     */
    handleSelected(item) {
      console.log("选择后参数", item.name);
      this.expressName = item.name;
    },
    /**
     * 提交快递信息
     */
    submit() {
      if (!this.expressNum) return this.$dialog.error("未填写快递单号");
      if (!this.expressName) return this.$dialog.error("未选择快递公司");
      submitExpressInfo({
        id: this.id,
        express_name: this.expressName,
        express_num: this.expressNum
      }).then(res => {
        this.$router.replace("/user/refund_detail?id=" + this.id);
      });
    },
    /**
     * 打开快递公司列表
     */
    logisticsOpen() {
      this.$refs.listPopUp.open();
    }
  }
};
</script>

<style scoped lang="scss">
.form {
  margin-top: 0.2rem;
  background-color: #fff;
  padding: 0 0.32rem;
  .form-item {
    padding: 0.28rem 0;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 0.32rem;
      color: #333;
    }
    .content {
      flex: 1;
      margin-left: 0.44rem;
      input {
        width: 100%;
        &::-webkit-input-placeholder{
          color:#ccc;
        }
      }
      .express-name-none{
        color:#ccc;
      }
    }
  }
}
.action-btn {
  position: fixed;
  bottom: 0.4rem;
  left: 50%;
  width: 7rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  background-color: #ec5d59;
  text-align: center;
  line-height: 0.9rem;
  color: #ffffff;
  transform: translateX(-50%);
  font-size: 0.36rem;
}
</style>
